import { Component, effect, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { FinzzleAuthService } from '@finzzle/auth';
import { OuiButtonModule } from 'omnium-ui/button';
import { appRoutePaths } from '../../app.paths';
import { StateCardComponent } from '../applications/shared/state-card/state-card.component';

// Page de repli : finzzleAuthGuard y redirige quand la connexion Entra échoue.
@Component({
  selector: 'dbw-auth',
  imports: [
    OuiButtonModule,
    StateCardComponent
  ],
  templateUrl: './auth.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent {
  readonly authService = inject(FinzzleAuthService);
  private readonly router = inject(Router);

  constructor() {
    effect(() => {
      if (this.authService.isReady() && this.authService.isAuthenticated()) {
        void this.router.navigateByUrl(appRoutePaths.home);
      }
    });
  }

  retryLogin(): void {
    void this.authService.login();
  }
}
